import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Building2, Loader2 } from 'lucide-react';

/**
 * Lightweight "Add New Vendor" dialog used inline on Restock.
 */
export const AddVendorDialog = ({
  open, onOpenChange,
  vendorName, setVendorName,
  saving, onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm rounded-xl">
      <DialogHeader>
        <DialogTitle className="font-heading text-xl text-[#1F2937] flex items-center gap-2">
          <Building2 className="text-[#0776BD]" /> Add New Vendor
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-2">
        <Label className="text-sm font-medium text-[#1F2937]">Vendor Name *</Label>
        <Input
          value={vendorName}
          onChange={(e) => setVendorName(e.target.value)}
          placeholder="Enter vendor name"
          className="h-12 rounded-lg border-gray-300"
        />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-lg">Cancel</Button>
        <Button onClick={onSave} disabled={saving || !vendorName.trim()} className="bg-[#0776BD] hover:bg-[#055A92] rounded-lg">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
          Add Vendor
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default AddVendorDialog;
